import axios from './axios';
import utils from '../lib/utils';

export default {
  patientManagementLogin(params) {
    return axios.post('/salePatient/login', params);
  },
  getSale(id) {
    return axios.get(`/salePatient/getSaleById?id=${id}`);
  },
  upDate(params) {
    return axios.post('/salePatient/update', params);
  },
  save(params) {
    return axios.post('/salePatient/save', params);
  },
  salePatient(params) {
    return axios.post('/salePatient/saleList', params);
  },
  getQrCode(mobile) {
    return axios.get(`/iguratimod/sendsms?mobile=${mobile}`);
  },
  getHospitalList() {
    return axios.post('/iguratimod/queryHospitalList');
  },
  loginIGU(params) {
    return axios.post('/iguratimod/login', params);
  },
  saveIGU(params) {
    return axios.post('/iguratimod/save', params);
  },
  getIGUList(params) {
    return axios.post('/iguratimod/queryPatientList', params);
  },
  shopOrderPay(data) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineDrug/recipeOrder/pay', data).then(
        (res) => {
          if (res.data.status && res.data.status == 'success') {
            resolve(res.data.data);
          } else {
            reject({ msg: '支付失败' });
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  getShopMenuData() {
    return new Promise((resolve, reject) => {
      axios.post('/product/productTypeList').then(
        (res) => {
          let data = res.data.data || [];
          let result = [];
          let sync = [];
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let temp = {
              code: item.id,
              name: item.productType,
              productType: item.productType,
              children: [],
            };
            result.push(temp);
            sync.push(this.getShopItem({ productType: item.id }));
          }
          Promise.all(sync).then(
            (response) => {
              if (response && response.length) {
                response.forEach((itemData, index) => {
                  let temp = itemData.map((item) => {
                    return {
                      id: item.id,
                      name: item.productName,
                      price: item.productPrice || 0,
                      ...item,
                    };
                  });
                  result[index].children.push(...temp);
                });
                resolve(result);
              }
            },
            (err) => {
              reject(err);
            }
          );
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  getShopItem(params) {
    return new Promise((resolve, reject) => {
      axios.get(`/product/list?${utils.exchangeParams(params)}`).then(
        (res) => {
          let data = res.data.data || [];
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  //加入购物车
  addShopCart(params) {
    return axios.post('/cart/add', params);
  },
  //获取购物车列表
  getShopList(params) {
    return axios.get(`/cart/list?${utils.exchangeParams(params)}`);
  },
  //删除购物车物品
  delectItem(params) {
    return axios.post('/cart/deleteProduct', params);
  },
  //查询用户地址
  getUserAddress(params) {
    return axios.get(`/product/queryAddress?${utils.exchangeParams(params)}`);
  },
  //保存用户地址
  saveUserAddress(params) {
    return axios.post('/product/saveAddress', params);
  },
  updateUserAddress(params) {
    return axios.post('/product/updateAddress', params);
  },
  // 删除用户地址
  delteUserAddress(id) {
    return axios.get(`/product/deleteAddress?id=${id}`);
  },
  // 商城订单列表
  getShopOrderList(data) {
    return axios.get(`/cart/queryOrder?${utils.exchangeParams(data)}`);
  },
  updateProductCount(data) {
    return axios.get(`/cart/updateProductCount?${utils.exchangeParams(data)}`);
  },
  productUnCheckedAll(data) {
    return axios.get(`/cart/productUnCheckedAll?${utils.exchangeParams(data)}`);
  },
  productCheckedAll(data) {
    return axios.get(`/cart/productCheckedAll?${utils.exchangeParams(data)}`);
  },
  productUnChecked(data) {
    return axios.get(`/cart/productUnChecked?${utils.exchangeParams(data)}`);
  },
  productChecked(data) {
    return axios.get(`/cart/productChecked?${utils.exchangeParams(data)}`);
  },
  queryOrderDetail(data) {
    return axios.get(`/cart/queryOrderDetail?${utils.exchangeParams(data)}`);
  },
  generateOrder(data) {
    return axios.post(`/cart/generateOrder`, data);
  },
};
